import { Component, computed, inject, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CountUpComponent } from '../count-up/count-up';
import { PpcButton } from '@design-system/button/button';
import { PpcEyebrow } from '@design-system/eyebrow/eyebrow';
import { PpcHeading } from '@design-system/heading/heading';

@Component({
  selector: 'app-hero',
  imports: [CountUpComponent, TranslatePipe, PpcButton, PpcEyebrow, PpcHeading],
  templateUrl: './hero.html',
  styleUrl: './hero.css',
})
export class HeroComponent {
  readonly joinClick = output<void>();

  private readonly translate = inject(TranslateService);

  private readonly HERO_IMAGE_PATH = '/assets/img/hero.jpg';
  private readonly STAT_DELAY_BASE_MS = 220;
  private readonly STAT_DELAY_STEP_MS = 140;

  protected readonly heroBackgroundImage = `url(${this.HERO_IMAGE_PATH})`;

  protected readonly titleLines = toSignal(this.translate.stream('hero.titleLines'), {
    initialValue: [] as string[],
  });

  private readonly rawStats = toSignal(this.translate.stream('hero.stats'), {
    initialValue: [] as { num: string; label: string }[],
  });

  protected readonly stats = computed(() =>
    this.rawStats().map((stat: { num: string; label: string }, index: number) => ({
      ...stat,
      delay: this.STAT_DELAY_BASE_MS + index * this.STAT_DELAY_STEP_MS,
    })),
  );
}
